module.exports = {
  home: '首页',
  organizer: '主办方',
  about: '关于',
  type: '参与形式',
  agenda: '会议',
  sponsor: '赞助',
  why_sponsor: '为何赞助',
  sponsors_exhibitors: '往届赞助商',
  partners: '合作伙伴',
  registration: '报名',
  tickets: '会议通票',
  free_tickets: '免费参与',
  home_title1: '未来医药峰会',
  home_title2: '运握未来医药发展契机',
  home_title3: '2023年11月23日',
  home_title4: '中国·上海',
  home_title5: '即刻参与',
  toll: '案例展示',
  too2: '项目披露',
  too3: '先锋企业',
  too4: '行业精英',
  too5: '颁奖盛典',
  guests: '演讲嘉宾',
  parallel_sessions: '平行专场',
  meetIntroText:'峰会介绍',
  intro1: '这并非孤立的顶层设计,而是政策纲领与医药行业研发、运营、供应链、营销等环节的数字化需求精准咬合:AI深度解析临床大数据，将靶点筛选效率提升50%;云计算打破多系统数据孤岛,让人工录入占比从60%锐减;物联网实时监控冷链运输,将温控误差控制在0.1°C安全线内:大数据精准分析31省市DRG差异,助力企业合规成本降低30%。',
  intro2: '当政策指引与企业实践形成共振,AI、大数据、云计算、物联网不再是冰冷的技术工具,而是化作驱动行业质变的“新质生产力引擎”!在此背景下,PharmaX未来医药峰会(上海)于8月21日应声启幕!作为聚焦医药数智化转型的高端实战平台,PharmaX已成功举办3届,累计吸引200+头部企业及1000+行业菁英参与。此次汇聚80+医药企业、150+行业领袖,以“政策落地x技术实践x生态共建”三维议程,直戳行业当下痛点。',
  // intro2: 'PharmaX专注于医药数智化和医药创新零售，与制药、医疗器械、生物技术、医疗诊断和医药零售商合作，定期举办行业指导和前瞻性系列会议，促进医药科技交流和创新，我们决心创建一个具有行业独特见解的创新商业社交平台。',
  // intro3: '请不要错失未来医药发展的新机遇，加入PharmaX同医药英才协同、高效打造形成以患者为中心、数据为纽带的开放共享的健康生态系统，共同探索产业数字化的未来。',
  conference_highlights: '会议亮点',
  // highlights_text: 'PharmaX提供多样的参与形式及会议亮点，以满足制药、生物科技、医疗诊断、医疗机构、医疗器械及医药零售、医药技术外围企业当前业务需求，实现其业务目标并获得预期的商业结果。',
  // highlights1: '前沿洞察',
  // highlights2: '推介会',
  // highlights3: '精准合作',
  // highlights4: '项目导向',
  // highlights5: '品牌曝光',
  // highlights6: '技术秀',
  highlights_tit1: '会前定制化痛点响应',
  highlights_text1: '采用“需求反推议程"的闭环设计,前期开展痛点预埋收集工作;中期按需求标签定向邀请适配嘉宾;最后经3轮筛选,确保150+参与者中80%的核心痛点与您同频,打造精准对接场景;',
  highlights_tit2: '政策剖析零距离',
  highlights_text2: '权威行业协会神秘代表现场拆解“数智医药”申报密码,案例企业适配评估讲解并解读项目验收细则,助您提前锁定专项扶持资金;',
  highlights_tit3: '技术落地全透明',
  highlights_text3: '药械、生物研发、诊断等企业CIO现场披露"踩坑-填坑"历程-AI研发踩过哪些数据坑?科技企业高层高光宣布实时技术，包括数据合规与安全,数字营销等创新与实时案例;',
  highlights_tit4: '高端资源一对一对接',
  highlights_text4: '闭门私享交流+展区技术秀+1对1商务引荐,全力赋能150位信息技术、数字化、制造、研发、运营、营销、供应链等医药领袖直指现规划与将落地项目合作',
  highlights_tit5: '会后长效赋能',
  highlights_text5: '加入“PharmaX专属群”,定期获取:非公开项目实践PPT;政策实时解读报告;同行问答通道:150+高管群内直接提问，诸多CIO等大咖翻牌解答。',
  meet_intro_tit:'数智化战略锚定',
  meet_intro_cont_1:'数智化浪潮下,医药工业如何锚定新质生产力航向?',
  meet_intro_cont_2:'Al+大数据渗透研发,能否让10年创新周期“腰斩”?',
  meet_intro_tit2:'合规与供应链攻坚',
  meet_intro_cont2_1:'数智化浪潮下,医药工业如何锚定新质生产力航向?',
  meet_intro_cont2_2:'Al+大数据渗透研发,能否让10年创新周期“腰斩”?',
  meet_intro_tit3:'营销与全球化破局',
  meet_intro_cont3_1:'处方药院外流转率不足20%,020能否撬起新增长极?',
  meet_intro_cont3_2:'医药出海新命题:Al+合规+供应链+营销,如何锻造全球化竞争力?',
  meet_intro_tit4:'技术深水区探索',
  meet_intro_cont4_1:'CBDT如何解码药企全生命周期智慧管理?',
  meet_intro_cont4_2:'数智药械工厂:概念蓝图如何落地为降本30%的实操方案',

  guests_title1: 'PHARMAX 峰会系列演讲嘉宾',
  guest1_1: '吴雅芳',
  guest1_2: '数据管理副总裁',
  guest1_3: '精鼎制药',
  guest2_1: '江新明',
  guest2_2: '市场营销副总裁',
  guest2_3: '亚虹制药',
  guest3_1: '王海军',
  guest3_2: '资深副总裁',
  guest3_3: '加科思新药',
  guest4_1: '张芳',
  guest4_2: '总经理',
  guest4_3: '陕西天士力医药物流',
  guest5_1: '毛化',
  guest5_2: '沙利文大中华区合伙人',
  guest5_3: '兼董事总经理',
  guest5_4: '弗若斯特沙利文',
  guest6_1: '谢祥云',
  guest6_2: '数据管理总监',
  guest6_3: '和黄医药',
  guest7_1: '胡茂化',
  guest7_2: '首席技术官',
  guest7_3: '1药网',
  guest8_1: '肖璟',
  guest8_2: '零售及电商负责人',
  guest8_3: '津村',
  guest9_1: '张舰娟',
  guest9_2: '大中华区药物管理解决',
  guest9_3: '方案高级业务总监',
  guest9_4: '碧迪医疗',
  guest10_1: '张青松',
  guest10_2: '董事长',
  guest10_3: '九州通医药集团',
  guest10_4: '物流有限公司',
  guest11_1: '佳娜',
  guest11_2: '战略推进室室长',
  guest11_3: '欧姆龙健康医疗(中国)',
  guest12_1: '郭立松',
  guest12_2: '中国数字创新中心负责人',
  guest12_3: '艾博抗',
  guest13_1: '刘康健',
  guest13_2: '董秘、副总裁',
  guest13_3: '润迈德医疗',
  guest14_1: '王志豪',
  guest14_2: '信息部高级总监',
  guest14_3: '复宏汉霖',
  guest15_1: '张飞舟',
  guest15_2: '中国区IT负责人',
  guest15_3: '百特',
  guest16_1: '姚彤彤',
  guest16_2: '信息安全及风险管理总监',
  guest16_3: '诺华制药',
  guest17_1: '王东',
  guest17_2: '首席执行官',
  guest17_3: '苏州施莱医疗器械有限公司',
  guest18_1: '蔡晶愚',
  guest18_2: '医药医疗行业资讯合伙人',
  guest18_3: '普华永道思略特',
  guest19_1: '程亚飞',
  guest19_2: '信息部负责人',
  guest19_3: '上海同济堂',
  guest20_1: '吴雅芳',
  guest20_2: '数据管理副总裁',
  guest20_3: '精鼎医药',
  guest21_1: '聂晓齐',
  guest21_2: '副总经理，质量管理负责人',
  guest21_3: '民海生物',
  guest22_1: '王兆阳',
  guest22_2: '人工智能创新负责人',
  guest22_3: '复宏汉霖',
  guest23_1: '吴维严',
  guest23_2: 'CIO',
  guest23_3: '迪安诊断',
  guest24_1: '刘莉',
  guest24_2: '数据管理总监',
  guest24_3: '先声药业',
  guest25_1: '庄弘达',
  guest25_2: '数据安全官',
  guest25_3: '葛兰素史克',

  guests_title2: 'PHARMAX 往届部分演讲嘉宾',
  past_guest1_1: '于翡',
  past_guest1_2: '中国供应链转型负责人',
  past_guest1_3: '罗氏制药',
  past_guest2_1: '余涛',
  past_guest2_2: '质量负责人',
  past_guest2_3: '艾尔建',
  past_guest3_1: '郑汶昊',
  past_guest3_2: '运营总监',
  past_guest3_3: '陕西天士力医药物流',
  past_guest3_4: '有限公司',
  past_guest4_1: '花放',
  past_guest4_2: '医药行业销售总监',
  past_guest4_3: '德马泰克',
  past_guest5_1: '陈亮',
  past_guest5_2: '物流总经理',
  past_guest5_3: '鹭燕医药',
  past_guest6_1: '钟宇亮',
  past_guest6_2: '供应链技术总监',
  past_guest6_3: '1药网',
  past_guest7_1: '鲁春波',
  past_guest7_2: '采购部、仓储部负责人',
  past_guest7_3: '鲁南制药',
  past_guest8_1: '曹骞',
  past_guest8_2: '高级运营总监&中国',
  past_guest8_3: '区供应链负责人',
  past_guest8_4: '拜耳医药',
  past_guest9_1: '管文辉',
  past_guest9_2: '中国区供应链负责人',
  past_guest9_3: '爱尔康(中国)',
  topic: '会议实践热话',
  topic1: '未来趋势',
  topic2: '线上到线下',
  topic3: '冷链',
  topic4: '数智化',
  topic5: '带量集采',
  topic6: '降本增效',
  topic7: '私域流量',
  topic8: '互联互通',
  topic9: '高科技',
  topicText1: '数智化浪潮下,医药工业如何锚定新质生产力航向?',
  topicText2: '当AI+大数据渗透研发,医药创新能否挣脱周期枷锁?',
  topicText3: '多省DRG差异困局,数智化如何打通跨区域合规任督二脉?',
  topicText4: '冷链“0.1℃生死线”,数智化追溯怎样筑牢药品安全防线?',
  topicText5: '处方药院外流转率不足20%,02O能否撬新增长极?',
  topicText6: 'CBDT :解码药企全生命周期智慧管理的通关密码',
  topicText7: 'AI重塑研发范式,靶点筛选效率飙升背后的创新逻辑',
  topicText8: '数智药械工厂:从概念蓝图,到降本提质的实践落地',
  topicText9: '医药出海新命题:AI+合规+供应链,如何锻造全球化竞争力?',
  topicText10: '私域流量复购率提升25%,营销数智化的“留客”新打法',
  form_of_participation: '参与形式',
  type_text: '为了获得更好的PharmaX参与体验，您可根据贵司的业务目标选择合适的参与形式。欢迎与我们分享更多关于您的医药项目、重点业务及关注的热点与痛点，我们亦可为您与贵司提供定制化的参与形式！',
  type1: '免费参与',
  type2: '参会代表',
  type3: '赞助商',
  type4: '演讲嘉宾',
  type5: '展商',
  type6: '合作伙伴',
  series_sponsorship: '系列赞助',
  footer1: 'PharmaX未来医药年度峰会',
  footer2: 'SoldOut零售年度峰会',
  footer3: 'PharmaX医药年度峰会',
  footer4: 'Logtalk年度峰会',
  footer5: '赞助商与展商',
  footer6: '参会代表&免费参与',
  footer7: '演讲与圆桌嘉宾',
  footer8: '免费参与',
  footer9: '扫码关注',
  footer10: '了解更多',
  footer13: '赞助支持',
  footer14: '媒体合作',
  about1: '关于会议',
  about1_text1: 'PharmaX未来医药峰会，是专注于中国及亚太医药市场的高端商务会议品牌，聚焦从制药研发、物流和供应链、零售流通、O2O到数字化等紧要环节，创新药产业研发、商业化、医疗健康投资等关键决策场景，以创新为主线，探讨未来医药的转型升级。',
  about1_text2: 'PharmaX为来自制药、医疗器械、生物技术、医疗诊断和医药零售企业的众多先行者、创新者搭建权威、专业、多维度的对话沟通平台，厘清创新发展难题、共商投资合作新战略、促成项目的转换和落地。',
  about2: '关于主办方',
  about2_text1: '作为一家富有创意的商业活动管理公司，会誉会展以创意连接为服务宗旨，以实现商业全球化互通为必修课，帮助各行各业的客户解决行业痛点、精准对接商机，成为立足华东、辐射全国、面向世界的行业活动实干者。',
  about2_text2: '会誉会展的核心团队均来自于国内外知名会展以及咨询企业。历经多年大型活动的经验沉淀，敏锐的洞察力、持续的创造力、高效的执行力、出色的协调力、专注且易于合作的职业精神、系统且精密的专业知识使得会誉会展团队从战略和规划到交付与审查，都是值得信赖的专业团队。',
  about3: '关于观众',
  about3_text1: '为可持续打造一个高效的B2B高端商务会议平台，PharmaX将基于当前政策趋势、行业热点与痛点，定向邀请医药行业影响力企业与决策者团队搭建系列互通有无的高端商务会议，助力拓展潜在医药人脉，通过一手的案例研究为其商业计划做赋能，并为该行业的可持续发展添砖加瓦。',
  about3_text2: '我们的参与观众包括：',
  about3_text3: '来自制药、医疗器械、生物科技、医疗诊断和医药零售商企业的高层管理人员；',
  about3_text4: '相关业务部门代表：T/商业智能/客户洞察力/数字化/战略规划与开发/市场研究/大数据/决策分析/商业分析/新产品规划/物流/预测/采购/智慧零售/品牌管理/产品管理/营销/门店管理/供应链/战略/商业分析开发/竞争情报/技术分析/运营/项目管理/风险管理/研究规划/研发/监管和许可/仓储和分销/电子商务/制造/质量...',
  premeeting_invitation: '会前邀请',
  premeeting_invitation_text1: '意向客户的会前定向邀请，是PharmaX闭门峰会的另外一大亮点，可助力企业客户会场精准获客，最大程度地突破时间差、地域差与信息差。',
  premeeting_invitation_text2: '再结合我们独特的推介会环节，可实现精准对接、明确反馈、高效转化，实质提高参会企业ROI。',
  invitation1: '拟定意向客户名单',
  invitation2: '精细调研分析',
  invitation3: '点对点定向邀请',
  invitation4: '实时更新与确认',
  invitation5: '最终名单公布',
  invitation6: '会场推荐会',
  jointype_text: 'PharmaX:提供多样化参与形式，以满足医药行业各类企业实际的项目需求和业务目标。请选择适配的参与形式，或与PharmaX组委会沟通更多定制化参与方案。',
  join_item1_1: '参会代表',
  join_item1_2: '可与PharmaX所有参与嘉宾沟通和交流',
  join_item1_3: '可参与PharmaX所有专场活动，听取主题演讲和圆桌讨论',
  join_item1_4: '可参与PharmaX所有展位参观和技术秀环节',
  join_item1_5: '茶歇交流与互动',
  join_item1_6: '参会代表注册',
  join_item1_7: '了解更多',
  join_item2_1: '赞助商',
  join_item2_2: '一对一商务高层引荐',
  join_item2_3: '会前、会中、会后全方位宣传和推广',
  join_item2_4: '适配业务需求的定制化赞助方案',
  join_item2_5: '可定向拓展医药行业潜在新客户',
  join_item2_6: '赞助商注册',
  join_item2_7: '了解更多',
  join_item3_1: '演讲嘉宾',
  join_item3_2: '展示您的实时成果和项目案例',
  join_item3_3: '让发声更具影响力',
  join_item3_4: '可参与PharmaX所有专场活动,参与主题演讲和圆桌讨论',
  join_item3_5: '茶歇交流与决策互动',
  join_item3_6: '演讲嘉宾注册',
  join_item3_7: '了解更多',
  join_item4_1: '展商',
  join_item4_2: '展示实时项目与解决方案',
  join_item4_3: 'Techshow发声独家排他性',
  join_item4_4: '高质量对接',
  join_item4_5: '参与所有会议环境',
  join_item4_6: '茶歇交流与互动',
  join_item4_7: '展商注册',
  join_item4_8: '了解更多',
  why_participate: '为何参与',
  participate_text: 'PharmaX是一个高端的商务社交平台，可提高品牌知名度，产生新的潜在客户，满足实质项目需求，并获得制药行业高层决策者的长期认可。请详细告知您的需求，我们将找到符合您预期商业目标的参与形式。',
  participate1: '对医药行业及医药项目的敏锐观察',
  participate2: '实质拓展您的医药社交圈与人脉',
  participate3: '定制化、高性价比赞助方案有效提升贵司的投入产出比',
  participate4: '与医药行业各个领域的专家面对面交流与合作',
  agenda_text: 'PharmaX议程仅针对医药行业时下热点与痛点展开探讨，会议议程中的每一个话题皆来自于制药、生物科技、医疗器械、医疗诊断与医药零售企业的400位医药行业影响者的反馈与建议，并希望每位PharmaX的参与嘉宾能从实时的案例分享与技术展示中真正洞察未来医药的趋势与发展，并把握转型、升级与合作商机。',
  someofthespeakersatthesummit: '峰会部分演讲嘉宾',
  agenda_acquisition: "获取",
  agenda_text2: '意向客户的会前定向邀请，是PharmaX闭门峰会的另外一大亮点，可助力企业客户会场精准获客，最大程度地突破时间差、地域差与信息差。',
  sponsor_text1: 'PharmaX的赞助商将有更多机会给与会者留下持续印象，同时也与该行业的决策者团队建立有效社交与合作关系。',
  sponsor_text2: 'PharmaX赞助商享受独家权益:',
  offers1: '一对一商务引荐',
  offers2: '主旨演讲',
  offers3: '头脑风暴',
  offers4: '推介会',
  offers5: '全方位会议宣传与推广',
  offers6: '意向客户现场引荐',
  offers7: '技术秀',
  offers8: '会前意向客户定向邀请',
  sponsor_text3: '填写下表，获取最佳适配赞助方案',
  sponsorshiphelpsthecompany: '赞助可助力公司',
  power1: "向医药市场推介新产品、新服务",
  power2: "吸引潜在客户与优质合作伙伴",
  power3: "提高品牌知名度与可信度",
  power4: "拓展会晤药企决策层",
  power5: "推进医药项目落地",
  power6: "展示项目成果并巩固行业地位",
  partners_text: 'PharmaX是一个创意十足的会议平台，可为医药行业特定监管机构、协会、院校及媒体提供多种合作伙伴参与形式。我们会根据合作伙伴的优势定制适配的参与形式，帮助他们更好融入并赋能医药行业。',
  partnersareavailableto: '合作伙伴适用于:',
  apply1: "您代表行业特定的监管机构、协会、教育机构",
  apply2: "或其他专门从事制药项目和主题的媒体公司",
  apply3: "您对制药行业的晋升感兴趣",
  availabletopartners: '合作伙伴可获得',
  zzs1: '罗技专注于设计与人们生活紧密相关的产品，为人们架起通往数字体验的桥梁。30多年前，罗技已经开始将计算机与人们紧密联系在一起。如今罗技投身于设计型产品，通过运算、游戏、视频和音乐将人们联系得日益紧密，转型成为云周边设备供应商，在全球140多个国家和地区展开业务。罗技公司旗下拥有罗技、罗技G、Jaybird、Ultimate Ears、Astro Gaming等多个品牌，业务涉及生产力及创造力、电竞游戏、视频协作、音乐和智能家居多个领域。',
  zzs2: 'G7易流，是全球领先的物联网软件服务公司，致力于提升产业生产力，让所有产业贡献者感受物流数字化带来的美好改变。面向生产制造与消费物流行业的货主及货运经营者提供软硬一体、全链贯通的SaaS 服务。G7易流已成为中国公路货运行业规模最大的企业服务公司与一体化数字服务平台。',
  zzs3: '作为Zoho Corporation的IT管理部门，ManageEngine优先考虑适用于所有业务的灵活解决方案，无论规模或预算如何。 ManageEngine开发全面的IT管理软件，重点是让您的工作更轻松。我们的 90多种产品和免费工具以您能承受的价格满足您的IT需求。从网络和设备管理到安全和服务台软件，我们将IT整合在一起，以实现优化IT的集成，全面的方法。',
  zzs4: '上海富勒信息科技有限公司，卓越的数字化供应链解决方案提供商，从中国走向世界。富勒提供的SCE（供应链执行）管理软件已被广泛应用于鞋服、时尚、零售、快消、医药、电商、电子、汽车、新能源、3C家电、家居建材、化工、机械、工业分销、生鲜冷链及第三方物流等行业，并已成为各行业领导企业的首选。富勒业务遍及全球24个国家，软件产品应用于超过2600个物流中心，管理着超过2400万平米的仓储面积，单仓日处理订单峰值164万+。富勒拥有一大批各行业的优质客户，包括顺丰、邮政速递、绫致、森马、时捷（美宜佳）、全家、江淮汽车、泛亚汽车、中车、隆基股份、TCL、海信、扬子江药业、科伦药业、宝洁、蒙牛、光明乳业、中粮可口可乐、鑫荣懋、百果园、郑明、DHL、KWE等知名品牌。',
  zzs5: '海柔创新(HAI ROBOTICS)是箱式仓储机器人系统的首创者和领航者，致力于通过机器人技术和人工智能算法，提供高效、智能、柔性、定制化的仓储自动化解决方案，为每个工厂和物流仓库创造价值。公司专注于箱式仓储机器人系统研发设计，实现机器人本体、底层定位算法、控制系统、机器人调度、智能仓储管理系统等核心元素的自主研发覆盖并已进行全球专利布局。旗下库宝系统(HAIPICK)已升级至第四代，是最早研发及投入商业使用的箱式仓储机器人系统，可助力仓库进行自动化管理，实现智能搬运、拣选、分拣，接受定制化需求。目前已在全球落地应用500+项目，广泛应用于鞋服、3PL、电商、电力、3C制造、医药、零售等各行业，多场景。使用库宝系统，客户可于一周内实现仓库自动化改造，提升80%-400%存储密度，并提高工人工作效率3-4倍。',
  zzs6: '昆仑联通创立于1998年，现已发展为全周期一站式IT运营服务商。结合市场发展趋势及自身优势技术资源，昆仑联通为客户呈现IT Infra数字化转型四大核心技术方案：IT资源平台、信息安全、IT运营管理、数字化办公，从人员、流程、技术、资源四个方面为客户IT技术升级转型全面保驾护航！公司业务由总部北京向全国辐射，在上海、深圳、苏州、南京、常州设有分公司，现有员工超500人，服务企业用户超20000家。',
  zzs7: '瑞仕格是全球领先的物流自动化系统集成商，为您提供数据与机器人驱动的、智能制药物流自动化解决方案，确保仓储流程可追踪追溯，以最佳成本效益合规，包括FDA、GMP等。瑞仕格提供包含咨询分析、概念方案、系统集成、项目实施、售后服务的交钥匙工程，已在全球成功交付2000+物流自动化集成项目，服务客户包括：丽珠、勃林格殷格翰、罗氏、Medline、Sanritsu、I.M.A SPA等。',
  zzs8: '腾讯云依托图像识别、大数据、人工智能等技术积累，构建医疗大健康产业云生态，助力数字化升级。为生命科学、基因测序等医药医疗各细分领域提供具备行业特征的多种数字化解决方案。上海云司科技是腾讯云授权服务中心，2014年成为腾讯云的合作伙伴，专注于腾讯云。为企业客户上云使用IAAS、PAAS、SAAS提供选型咨询、架构设计等支持服务。帮助企业选好云、用对云、管好云，为全国用户提供更优质的上云服务是我们的目标。',
  zzs9: '商越科技是面向大中型企业提供采购数字化全景解决方案的智能公司，通过商越的智能采购中台、S a a S应用及运营服务帮助每个客户搭建专属的采购互联网平台，让企业采购全程在线化、数字化、智能化，提升效率、降低成本。',
  zzs10: '实在智能是中国AI准独角兽和RPA头部企业，行业领先的超自动化解决方案提供商。致力于通过全国产、全自研的AI技术与RPA产品，打造广泛应用于医药、电商、金融、能源、制造业等行业以及政府企业的“数字员工”，至今已成功服务了国控广西、康美药业、广东省中医院珠海医院、同科医药、开心堂、漱玉平民、美年大健康等医药企业和医疗单位的数字化建设项目，助力企业及政府数字化改革和转型升级。',
  zzs11: '新钛云服秉持“以专业成就每一位客户”的使命，致力于为数字化企业提供专业的云和安全管理服务（Cloud MSP & MSSP），帮助数字化企业高效构建和管理IT基础架构、应用系统和安全管理体系，保障业务系统安全稳定地运行，为企业数字化转型保驾护航。',
  zzs12: '医百科技，聚焦于药械企业营销端的技术赋能，依托Pharma MarTech技术，服务药企营销全场景，助力企业营销数字化转型。医百自主研发的100.pMarTech技术SaaS平台，涵盖100.eMarketing医药数字化营销产品、100.CRM+智能代表工作台、100.eHospital互联网医院和100.AiData智能数据平台四大产品业务矩阵，为医药企业提供“数字化学术推广、数字化销售管理和数字化医患管理”的整体解决方案，覆盖“企-医-患-药”的营销全链路。对外实现30+营销场景线上化，对内可建立贯通企业多部门的整合营销管理体系，帮助药企打通内外融合的数字化营销闭环，开创药企从数字化运营到一体化管理的新局面。医百科技，中国领先的医药营销数字化转型服务提供商，已服务药企客户千余家，协会客户100余家',
  zzs13: '上海正也信息科技有限公司，是一家专注于医药行业营销信息化建设的高新技术企业。公司致力于将多年的互联网行业经验、移动APP开发经验与用户研究分析数据模型结合中国医药行业市场用户行为，挖掘传统行业在移动互联网时代转型的可行性解决方案。正也科技利用创新的互联网技术、移动互联网技术，为医药营销管理与分析，提供可视化、标准化的管理与推广信息化系统；并帮助客户打造独特的、迭代的现代数字营销与管理互动方案。同时，我们自主开发企业管理的多屏合一的销售终端信息系统（S2P医药智能营销信息化管理平台），立足于移动端与PC端的数据交互，从而实现主数据管理、人员管理、客户拜访/市场活动管理、流向管理、绩效管理、费用管理、代理商合规管理等图表化呈现与系统化管理。',
  zzs14: '上海自然而然信息科技有限公司是国内首家提出AutoPaaS概念的自动化创新企业，主要为企业级客户提供一站式业务自动化解决方案，团队主要成员来自世界顶尖技术公司。主要产品“自然机器人”融合了界面自动化和接口自动化技术，核心引擎稳定可靠，在钉钉、企微、飞书等各大办公平台完成快速启动协同办公，同时在医药、零售、电商、制造等行业为客户提供丰富的产品与数字化解决方案，帮助客户降本增效，是值得信赖的先进自动化服务供应商。',
  zzs15:'作为京东集团面向企业、政府等机构的技术服务品牌，京东云是最懂产业的数智化解决方案提供商，致力于为企业、金融机构、政府等各类客户提供以供应链为基础的数智化解决方案。依托公、专、混的全栈式云产品矩阵，京东云融合了人工智能、大数据、物联网等前沿科技，在零售、物流、健康、智能城市、金融科技等行业领域为客户提供了丰富的产品与数字化解决方案，帮助客户降低成本、提升效率，是最值得信赖的产业数字合作伙伴。',
  zzs16:'嘉民是一家全球性的工业地产集团。我们在17个国家持有、开发和管理工业地产。机构投资者可以通过我们的合作伙伴关系，享有我们的专业投资管理服务和物业资产。我们凭借对本地市场的了解以及我们30多年的行业经验做出决策。嘉民规划长期发展蓝图。我们拥有自己的团队，资产规模，专业知识，基础设施和资本实力，培育与全球客户的长期合作关系，并具有适应当地业务需求的灵活性。我们在物流、零售、电子商务和汽车等领域拥有丰富的客户基础。我们以客户为中心，建立了持久的“持有+开发+管理”模式，原因很简单且始终如一：为客户的成功创造卓越空间。在这一模式下，我们所做的一切都秉承以客户的成功为中心的准则。',
  zzs17:'安得智联建立端到端全链路数智化的物流运营迭代能力，为客户提供从原料至成品的生产精益物流，线上线下一盘货，To1B/C一体化，仓干配一体化及送装一体化服务的系统解决方案，协助企业推动渠道变革与供应链效率优化，提升竞争优势，助力客户实现可持续性发展。',
  zzs18:'霍尼韦尔智能仓储作为领先的自动化仓储解决方案提供商，致力于为全球零售商、制造商和物流商提高生产率。通过输送、分拣、立体库、订单拣选等设备和方案的组合，霍尼韦尔提高灵活性、效率和准确性，为企业实现竞争优势并优化运营绩效，同时遍布全球的服务网络为每个项目提供全天候的生命周期技术支持。',
  zzs19:'易流科技深耕供应链物流数字化16年，提出了供应链物流数字化（IoT）基础设施生态图谱，在物流基础设施物联网化，供应链全链条数字化，物流全场景智能化上不断推陈出新。从司机的安全驾驶，到冷链全链条的温控追溯，到物流订单的端到端可视，到仓库与运输的协同，再到基于数据与算法的应用，让数据代替经验，让算法辅助决策。期待能够供应链物流的货主和物流企业优化成本，安全可控，时效精准，体验重塑。',
  zzs20:'深圳市大族机器人有限公司，为上市公司——大族激光科技产业集团股份有限公司（股票名称：大族激光，股票代码：002008）投资组建，是在大族机器人研究院100多人的研发团队基础上孵化而成的国家级高新技术企业。公司成立于2017年9月，总部和生产基地位于深圳市宝安区大族激光全球智能制造产业基地，在中国天津、无锡和德国设有子公司。公司致力于智能机器人在工业、医疗、物流、教育、服务等领域的研发、推广和应用，用机器人技术为人民服务。',
  ticket1: '免费参会',
  ticket2: '0元/位',
  ticket3: '免费报名',
  ticket4: '限10月30日截至',
  ticket5: '1天会议',
  ticket6: '技术秀参观',
  ticket7: '展区参观',
  ticket8: '茶歇交流',
  ticket9: '免费注册与签到通道',
  ticket10: '电子会议会刊',
  ticket11: '五星自助午宴',
  ticket12: '同声传译',
  ticket13: '根据大会实际情况安排',
  ticket14: '会后全套可公布PPT',
  ticket15: '一对一商务引荐',
  ticket16: '高层闭门交流',
  ticket17: 'SVIP专属交流群',
  ticket18: '会后引荐',
  ticket2_1: 'VIP参会代表',
  ticket2_2: '0元/位(仅限金融/医药/制造/甲方业务决策层)',
  ticket2_3: '3,000元/位',
  ticket2_4: '即刻注册',
  ticket2_5: '10月30日恢复原价',
  ticket2_6: '1天会议',
  ticket2_7: '3个专场自由进出',
  ticket2_8: '展区参观',
  ticket2_9: '茶歇交流',
  ticket2_10: '专属注册与签到通道',
  ticket2_11: '纸质会议会刊',
  ticket2_12: '茶歇糕点',
  ticket2_13: '专属会议胸卡',
  ticket2_14: '专属席卡与坐席',
  ticket2_15: '五星自主午宴',
  ticket2_16: '同声传译',
  ticket2_17: '会后全套可公布PPT',
  ticket2_18: '一对一商务引荐',
  ticket2_19: '高层闭门交流',
  ticket2_20: 'SVIP专属交流群',
  ticket2_21: '会后引荐',
  ticket3_1: 'SVIP参会嘉宾',
  ticket3_2: '3,000元/位',
  ticket3_3: '6,800元/位',
  ticket3_4: '即刻注册',
  ticket3_5: '10月30日恢复原价',
  ticket3_6: '2天会议',
  ticket3_7: '展区参观',
  ticket3_8: '茶歇交流',
  ticket3_9: '专属注册与签到通道',
  ticket3_10: '纸质会议会刊',
  ticket3_11: '茶歇糕点',
  ticket3_12: '专属会议胸卡',
  ticket3_13: '专属席卡与坐席',
  ticket3_14: '专属会议胸卡',
  ticket3_15: '五行自助午宴',
  ticket3_16: '同声传译',
  ticket3_17: '会后全套可公布PPT',
  ticket3_18: '根据大会实际情况安排',
  ticket3_19: '一对一商务引荐',
  ticket3_20: '高层闭门交流',
  ticket3_21: 'SVIP专属交流群',
  ticket3_22: '会后引荐',
  TermsandConditionsofParticipation: '参与条款与适用条件',
  terms1: '适用',
  terms1_text1: '此免费门票仅适用于医药企业及医药科技相关的部门/业务负责人或总监及其以上职位申请与注册；',
  terms1_text2: '监管机构、行业协会、学会及院校可免费申请参与；',
  terms1_text3: '金融科技外围企业一律不适用该参与形式，需按照会议通票、赞助商或展商形式付费参与；',
  terms1_text4: '个人申请参与一律不受理。',
  terms2: '审核与受理',
  terms2_text1: '免费门票申请需如实详尽填写，待组委会审核与受理：',
  terms2_text2: '申请信息不充分或虚假，组委会一律不予回复；',
  terms2_text3: '申请提交后，组委会将于1-2个工作日审核与受理；',
  terms2_text4: '注册成功后，组委会仅通过申请者所填的企业邮箱发送会议注册成功通知，并附有会议信息，包括参与者的签到号、签到时间、会议地点与参与须知等；',
  terms2_text5: '会议现场签到需出示真实注册信息方可入场；',
  terms2_text6: '免费门票申请仅限300位，且有报名时间限制，超额、超时报名需按照会议通票付费参与；',
  terms2_text7: '会议现场临时报名注册需按会议通票价格付费与会；',
  terms2_text8: '本次会议为高端闭门峰会，严禁冒用、顶替他人信息进行参与。',
  terms3: '更新与通知',
  terms3_text1: '会议筹备期间，组委会将通过申请者所填企业邮箱陆续更新有关会议内容确认情况，包括会议内容、演讲嘉宾确认、参与企业确认等；',
  terms3_text2: '会前一周组委会将通过邮件形式发送会前通知；',
  terms3_text3: '会前一天组委会将通过电话/短信形式发送最终会议通知；',
  terms3_text4: '发言人与议程实时更新，请以会议现场最终议程为准。若部分演讲集嘉宾临时取消，我们将积极寻找同等级别或同等影响力的替代者。',
  terms4: '注意事项',
  terms4_text1: '相遇不易，机不可失，请珍惜难得的学习、交流与合作机会，准时与会；',
  terms4_text2: '组委会不提供任何食宿与差旅安排，请提请妥善安排好个人出行；',
  terms4_text3: '如因个人安排无法按时出席此次会议，请提前至少15个工作日通知组委会以便我们合理统筹与安排。若未提前告知，组委会将永不受理其今后任何参与申请；',
  terms4_text4: '会议现场禁止散发传单、禁止干扰会议正常秩序。如有任何不恰当行为的个人，组委会有权现场取消其参与资格；',
  terms4_text5: '申请参与即表示您已知晓且无任何追加条件并授权主办方可与会议当日现场拍摄、录制可能包含您的音频、视频、图片素材，且今后仅用于PharmaX系列活动的宣传与推广。',
  freetickets: '免费门票',
  day1: '2023年7月20日 第一天',
  day1_1: '开幕致辞',
  day1_2: '主题演讲：零售差异化发展的核心驱动力',
  day1_3: '主题演讲：“颜值经济” 软性竞争力，探索元宇宙时代的消费新机会',
  day1_4: '主题演讲：渠道数字化创新引领品牌复兴，开创中国白酒新消费格局',
  day1_5: '上午茶歇、展台参观技术秀、互动交流',
  day1_6: '主题演讲：心怀用户，做信任经济用户运营',
  day1_7: '赞助商机会',
  day1_8: '圆桌讨论：打通和优化全链路新零售，实现“品效销合一”的整体提升',
  day1_9: '午餐时间',
  day1_10: '主题演讲：DTC2.0时代，体育行业如何抢占先机？',
  day1_11: '赞助商机会',
  day1_12: '主题演讲：加速数智化布局，重构零售全链路',
  day1_13: '主题演讲：探索“数智融合” ，引领品类增长模式创新',
  day1_14: '下午茶歇、展台参观技术秀、互动交流',
  day1_15: '圆桌讨论：新消费时代，品牌如何利用零售与营销技术升级拓展',
  day1_16: '会议闭幕',
  day2: '2023年7月21日 第二天',
  day2_1: '开幕致辞',
  day2_2: '主题演讲：以消费者为中心，实现长期价值创造',
  day2_3: '主题演讲：品牌渠道双赋能，加速布局健康休食市场',
  day2_4: '主题演讲：消费新世界，自我革新渗透新生代群体',
  day2_5: '上午茶歇、展台参观技术秀、互动交流',
  day2_6: '主题演讲：即时零售，开启智慧电商“鲜”时刻',
  day2_7: '赞助商机会',
  day2_8: '圆桌讨论：实体零售数字化转型,智慧门店打通全场景',
  day2_9: '午餐时间',
  day2_10: '主题演讲：创新营销打造好利来糕点王国',
  day2_11: '赞助商机会',
  day2_12: '主题演讲：数字化技术赋能全产业链、品牌的可持续发展',
  day2_13: '主题演讲：存量竞争时代，品牌差异化营销',
  day2_14: '下午茶歇、展台参观技术秀、互动交流',
  day2_15: '圆桌讨论：新品牌如何打造核心竞争力，抢占用户心智',
  day2_16: '会议闭幕',
}